import React, { useState } from 'react'

const CgiBd = ({
  anxiety = {
    latest: 'None',
    previous: 'None',
    entry: 'None',
  },
  dates = {
    entry: '07/28/2025',
    previous: '04/15/2026',
    latest: '05/12/2026',
  },
  bipolar = {
    latest: 'None',
    previous: 'Minimal',
    entry: 'Moderate',
  },
  initialSummary = 'Overall, the August results show a mixed picture. Depression symptoms are minimal, and well-being has improved since July. Mania symptoms have increased, and sleep difficulties are slightly greater. The August visit also indicates ongoing mood and anxiety concerns. These changes can help guide the next conversation with your care team.',
  onApprove,
  onSaveDraft,
}) => {
  const [summary, setSummary] = useState(initialSummary)

  const columns = [
    { key: 'entry', label: 'At Enrollment' },
    { key: 'previous', label: 'Previous' },
    { key: 'latest', label: 'Now' },
  ]

  const rows = [
    { label: 'Severity of BD', values: bipolar },
    { label: 'Severity of Anxiety', values: anxiety },
  ]

  const isSummaryEmpty = !summary.trim()

  const patientName = 'Jennifer Test';
  const previousReportDate = '04/15/2026';
  const currentReportDate = '05/12/2026';

  return (
    <section style={styles.container}>
    <header style={styles.reportHeader}>
      <h2 style={styles.reportTitle}>
        {patientName}: Patient Report [{previousReportDate} - {currentReportDate}]
      </h2>
      <div style={styles.reportSubtitle}>
        How are you doing?
      </div>
      </header>
      <div style={styles.summaryWrapper}>
        <label htmlFor="cgi-bd-summary" style={styles.summaryLabel}>
          Overall summary
        </label>

        <textarea
          id="cgi-bd-summary"
          value={summary}
          onChange={event => setSummary(event.target.value)}
          rows={6}
          style={styles.textarea}
        />

        <div style={styles.buttonGroup}>
          <button
            type="button"
            onClick={() => onApprove?.(summary)}
            disabled={isSummaryEmpty}
            style={{
              ...styles.approveButton,
              ...(isSummaryEmpty ? styles.disabledButton : {}),
            }}
          >
            Approve
          </button>
        </div>
      </div>

      <div className="title6">
        Clinician rating:
      </div>

      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th
                scope="col"
                style={{ ...styles.cell, ...styles.labelCell }}
              />
              {columns.map(column => (
                <th key={column.key} scope="col" style={styles.cell}>
                  {column.label}
                  <br />
                  <span style={styles.dateLabel}>
                    {dates[column.key] || ''}
                  </span>
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.map(row => (
              <tr key={row.label}>
                <th
                  scope="row"
                  style={{ ...styles.cell, ...styles.labelCell }}
                >
                  {row.label}
                </th>

                {columns.map(column => (
                  <td
                    key={column.key}
                    style={{
                      ...styles.cell,
                      ...(column.key === 'latest' ? styles.nowCell : {}),
                    }}
                  >
                    {row.values?.[column.key] || 'Not assessed'}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    color: '#222',
    width: '100%',
  },
  reportHeader: {
    marginBottom: 20,
  },
  reportTitle: {
    margin: '0 0 8px',
    fontSize: 20,
    fontWeight: 600,
  },
  reportSubtitle: {
    fontSize: 18,
    fontStyle: 'italic',
  },
  summaryWrapper: {
    marginBottom: 24,
  },
  summaryLabel: {
    display: 'block',
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 8,
  },
  textarea: {
    boxSizing: 'border-box',
    width: '100%',
    padding: 12,
    border: '1px solid #d8d8d8',
    borderRadius: 4,
    fontFamily: 'inherit',
    fontSize: 14,
    lineHeight: 1.6,
    color: '#222',
    resize: 'vertical',
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 8,
  },
  approveButton: {
    padding: '5px 12px',
    width: '100px',
    border: '1px solid #2e7d32',
    borderRadius: 4,
    backgroundColor: '#2e7d32',
    color: '#fff',
    fontSize: 12,
    cursor: 'pointer',
  },
  draftButton: {
    padding: '8px 16px',
    border: '1px solid #607d8b',
    borderRadius: 4,
    backgroundColor: '#fff',
    color: '#455a64',
    fontSize: 14,
    cursor: 'pointer',
  },
  disabledButton: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  dateLabel: {
    fontSize: 11,
    fontWeight: 400,
    color: '#607d8b',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  table: {
    borderCollapse: 'collapse',
    width: '100%',
    minWidth: 600,
  },
  cell: {
    border: '1px solid #d8d8d8',
    padding: '12px 16px',
    textAlign: 'center',
  },
  labelCell: {
    fontWeight: 500,
    textAlign: 'left',
  },
  nowCell: {
    fontWeight: 600,
  },
}

export default CgiBd
